// extracted by mini-css-extract-plugin
export default {"featuredTile":"styles_featuredTile__aHTu8","standardTile":"styles_standardTile__ir-bk"};